module.exports = "<task-details [taskDetails]=\"task\" [showTaskActions]=\"false\"></task-details>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/task/taskpopout/task-popout.component.html
// module id = 2351
// module chunks = 0